module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_tool_shadow-1.060ccd15.png";